import { SCREENS } from '../constants';

const urlRegex = /\/retrospectives(\/([^/]+))?/;
const DEFAULT_REDIRECT_STATE = { url: '/retrospectives', valid: false };

export const ROUTE_PATHS = {
  [SCREENS.WORKSPACE]: () => '/retrospectives',
  [SCREENS.BOARD]: ({ currentRetrospectiveId }) =>
    `/retrospectives/${currentRetrospectiveId}`,
  [SCREENS.SETTINGS]: () => `/retrospectives/settings`,
  [SCREENS.CHECKOUT_PAYMENT]: () => '/retrospectives/checkout',
};

export const getNextState = (nextUrl = '') => {
  urlRegex.lastIndex = 0;
  const match = nextUrl.match(urlRegex);
  if (!match) return DEFAULT_REDIRECT_STATE;

  const [fullUrl, , retrospectiveId] = match;
  if (fullUrl !== nextUrl) return DEFAULT_REDIRECT_STATE;

  const screen =
    SCREENS[(retrospectiveId || '').toUpperCase()] ||
    (retrospectiveId ? SCREENS.BOARD : SCREENS.WORKSPACE);

  return {
    screen,
    retrospectiveId,
    url: fullUrl,
    valid: true,
  };
};
